import { render, staticRenderFns } from "./GatewaysCPay.vue?vue&type=template&id=227fe090&"
import script from "./GatewaysCPay.vue?vue&type=script&lang=js&"
export * from "./GatewaysCPay.vue?vue&type=script&lang=js&"
import style0 from "./GatewaysCPay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports